import type { Match } from '@uefadigital/panenka';
import { PkButton, PkDropdown, PkIcon, PkMenu, PkMenuItem, PkSpinner } from '@uefadigital/panenka-react';
import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { generatePdfLinks, useAvailablePdfLinks } from '../../hooks/useAvailablePdfLink';

import PDF from 'assets/pdf.svg';
import UnavailablePDF from 'assets/unavailablePdf.svg';

interface Link {
  link: string;
  name: string;
}

const PrintOutsButton = ({ matchData }: { matchData: Match }) => {
  const { t } = useTranslation();
  const ref = useRef<HTMLPkDropdownElement>(null!);
  const [enableLoad, setEnableLoad] = useState(false);
  const availableLinks = useAvailablePdfLinks(matchData, enableLoad);
  const pdfLinks = generatePdfLinks(matchData);

  const handleClickDropdown = useCallback(() => {
    setEnableLoad(true);
  }, []);
  return (
    <PkDropdown className="pk-d--none pk-d-sm--block" panel-height="340px" ref={ref} onPkShow={handleClickDropdown}>
      <PkButton slot="trigger" appearance="outlined" width="140">
        {t('print_outs')}
        <PkIcon name="navigation-chevron-down" className="pk-ml--xs" />
      </PkButton>
      <PkMenu hide-section-divider class="store-dropdown__menu">
        {!availableLinks?.loaded && <PkSpinner className="pk-align--middle pk-mt--xl4" />}
        {pdfLinks.map((pdfLink: Link, index) => {
          const isLinkEnabled = availableLinks?.links.find((available) => available.name === pdfLink.name);
          return (
            <PkMenuItem
              target={`${isLinkEnabled ? '_blank' : ''}`}
              href={`${isLinkEnabled ? pdfLink.link : ''}`}
              key={index}
              className={!availableLinks?.loaded && 'pk-d--none'}
            >
              <img alt="PDF" src={`${isLinkEnabled ? PDF : UnavailablePDF}`} width={24} slot="prefix" />
              <span
                slot="prefix"
                className={`${
                  isLinkEnabled ? 'pk-text--text-01' : 'pk-text--text-03'
                } pk-line-height--sm pk-font-weight--normal pk-font-size--m pk-text--wrap`}
              >
                {t(pdfLink.name)}
              </span>
              <PkIcon name="actions-download" color={`${isLinkEnabled ? 'interaction' : 'ui-03'}`} slot="suffix" />
            </PkMenuItem>
          );
        })}
      </PkMenu>
    </PkDropdown>
  );
};

export default PrintOutsButton;
